export default __webpack_public_path__ + "static/media/Ring of Warmaster's Wrath.a51c3ca0.jpg";